import { skipToken, useInfiniteQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { components } from '@/types/apiSchema';

import { chatEndpoints } from './constants';
import { chatQueryKeys } from './queryKeys';

type ChatsPageApi =
  components['schemas']['CursorPageResponseOfAiConversationSummaryResponse'];

const CHATS_PAGE_SIZE = 20;

/** The user's chats in a workspace, newest activity first, a page at a time. */
export const useChatsQuery = (tenantId: string | undefined) => {
  const query = useInfiniteQuery({
    queryKey: chatQueryKeys.list(tenantId ?? ''),
    initialPageParam: undefined as string | undefined,
    queryFn: tenantId
      ? async ({ pageParam }) => {
          const { data } = await fetchClient.GET(chatEndpoints.chats, {
            params: {
              query: { tenantId, cursor: pageParam, limit: CHATS_PAGE_SIZE },
            },
          });
          return data;
        }
      : skipToken,
    getNextPageParam: (lastPage: ChatsPageApi | undefined) =>
      lastPage?.nextCursor ?? undefined,
  });

  return {
    ...query,
    chats: query.data?.pages.flatMap((page) => page?.items ?? []) ?? [],
  };
};
